import { memo } from "react";
import tw from "twin.macro";
import AboutImg from "../images/AboutUs/about-img.png";
import Image1 from "../images/AboutUs/image1re.jpg";
import image2 from "../images/AboutUs/Image2.jpg";
import AboutBack from "../images/AboutUs/back.png";
import retailShop from "../images/AboutUs/retailShop.webp";
import retail from "../images/AboutUs/retail.jpg";
import shortShop from "../images/AboutUs/short shop.jpg";
import product from "../images/AboutUs/product.jpg";
import silks from "../images/AboutUs/silks.jpg";
import members from "../images/AboutUs/members-banner.jpg";

// eslint-disable-next-line 
const Container = tw.div`text-center`;

function AboutUs({ branch }) {
  return (
    <>
      <div className="container" tw="lg:py-16 py-10 ">
        <div className="row align-items-center flex-column-reverse flex-lg-row py-2">
          <div className="col-md-12 col-lg-6">
            <h1 tw="text-5xl my-5 lg:mt-2">WHO WE ARE!!</h1>
            <div className="ptSans text-base">
              <p tw="text-zinc-300 text-xl">
                <strong> Jai Maruthi Jewellery</strong> Our Journey Began In 1998 With A Simple Bicycle And A Small Trunk Of Silver Studs. What Started As A Humble Initiative Grew Through Dedication, Resilience, And An Unwavering Commitment To Quality.
              </p>
              <p tw="text-zinc-300 text-xl">
                From Establishing A Small Shop In 2002 To Steadily Expanding Over The Years, Every Milestone Reflects The Trust Our Customers Have Placed In Us. Each Phase Of Growth Has Been Driven By Hard Work And A Passion For Delivering Excellence.
              </p>
              {/* <p tw="text-zinc-300 text-xl">
                "Jai Maruthi Jewellery”
              </p> */}
            </div>
          </div>
          <div className="col-md-12 col-lg-6 ">
            <img src={AboutBack} alt="About-Img" tw="absolute right-0 top-0 -z-10 hidden lg:block w-5/12" />
            <img src={Image1} alt="About-Img" className="img-fluid m-auto" tw="transform transition duration-500 hover:scale-110" />
          </div>
        </div>

        {/* <div className="row py-5 mt-lg-2 ">
          <div className="col-md-12 col-lg-6">
            <img src={product} alt="About Our Retail Shop" className="w-100" tw="rounded-xl" />
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="executive my-3 my-md-3">
              <p tw="text-zinc-300 text-xl">
                Today, With The Launch Of New Store Of Jai Maruthi Jewellery In 2024, We Carry Forward The Same Values That Built Our Foundation—Trust, Craftsmanship, And Customer Satisfaction. Our Story Stands As A Testament That With Determination, Anything Is Possible.
              </p>

            </div>
          </div>
        </div> */}

        <div className="row  flex-column-reverse flex-lg-row py-2">
           <div className="col-md-12 col-lg-6 ">
            <img src={shortShop} alt="About-Img" className="img-fluid m-auto" tw="transform transition duration-500 hover:scale-110" />
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="ptSans text-base">
              <h6 tw="text-5xl my-3 lg:mt-2">Retail showroom</h6>
              <p tw="text-zinc-300 text-xl">
                Today, With The Launch Of New Store Of Jai Maruthi Jewellery In 2024, We Carry Forward The Same Values That Built Our Foundation—Trust, Craftsmanship, And Customer Satisfaction. Our Story Stands As A Testament That With Determination, Anything Is Possible.
              </p>
              <h6 tw="text-2xl my-5 lg:mt-2">FAIR PRICING</h6>
              <p tw="text-zinc-300 text-xl">
                We believe luxury should be accessible. Our ethically sourced jewelry is priced fairly, ensuring you get the best value without compromising on quality.
              </p>
              {/* <h4 tw="text-2xl my-5 lg:mt-2">UNMATCHED QUALITY</h4> */}
              {/* <p tw="text-zinc-300 text-xl">
                Designed to last a lifetime, our jewelry is crafted from 99.9% pure silver, adorned with intricate designs that celebrate heritage and modern fashion alike.
              </p> */}
            </div>
          </div>
        </div>

        <div className="row py-5 mt-lg-2">
          <div className="col-md-12 col-lg-6">
            <div className="executive my-3 my-md-3">
              <h4 tw="text-2xl my-5 lg:mt-2">HAPPY CUSTOMERS/CUSTOMER REVIEWS</h4>
              <p tw="text-zinc-300 ">
                <ul tw="text-zinc-300 list-disc text-xl">
                  <li>Highly recommended for those who are looking for perfect jewellery. Good ambience.</li>
                  <li>The staff was very polite and helped me to choose the perfect jewellery. Recommended.</li>
                  <li>Jai Maruthi is absolutely a one stop destination for those who are looking for premium jewellery. I loved it.</li>
                  <li>Very unique and good collection of silver jewellery. I'm a regular customer here. I love their collections.</li>
                  <li>Fantastic jewellery collections. I love their offers. Good store ambience.</li>
                </ul>
              </p>
              <h4>CONTACT ADDRESS</h4>
              <ul style={{ listStyle: "none" }} >
                <li><i className="bi bi-geo-alt-fill"></i>
                {Object.keys(branch).length > 0 && (
                  <>
                    {' '}{branch.branchAddress.address1}, {branch.branchAddress.address2}, <br />
                    {branch.branchAddress.talukName}, {branch.branchAddress.districtName}, <br />
                    {branch.branchAddress.stateName}, {branch.branchAddress.pincodeNumber}
                  </>
                )}</li>
                <li><i className="bi bi-telephone-fill"></i> +91 {branch.mobile}</li>
                <li><i className="bi bi-whatsapp"></i> 6382215042</li>
                <li><i className="bi bi-envelope-fill"></i> {branch.email}</li>
              </ul>
            </div>
          </div>
             <div className="col-md-12 col-lg-6">
            <img src={retail} alt="About-Img" className="img-fluid m-auto" tw="transform transition duration-500 hover:scale-110" />

            {/* <img src={retail} alt="retail shop" className="w-100" tw="rounded-xl" /> */}
          </div>
        </div>
      </div>
    </>
  );
}
export default memo(AboutUs);